<mat-accordion>
  @for (expantionPanel of input.ExpansionPanels; track expantionPanel) {
    <ng-container [dynamicWidget]="expantionPanel" [context]="context" />
  }
</mat-accordion>
